export const getOptionsFromEnum = <T extends Record<string, unknown>>(e: T) => {
  const res = (Object.keys(e) as Array<keyof typeof e>).map((key) => ({
    id: key,
    name: e[key],
    label: e[key],
  }));

  return res;
};
